import React from 'react';
import HappyLoadingIcon from '@stencil/icons/src/HappyLoadingIcon/HappyLoadingIcon';

import * as S from './GoTribeThankYouCard.styles';

interface GoTribeThankYouCardProps {
  isMweb?: boolean;
}

export const GoTribeThankYouCard: React.FC<GoTribeThankYouCardProps> = ({
  goTribeLoyaltyData,
  isMweb = false,
}) => {
  return (
    <S.GoTribeReviewFooterWrapper isMweb={isMweb}>
      <S.GoTribeReviewFooterHeaderWrapper>
        <S.GoTribeSuperStarImgWrapper>
          {!!goTribeLoyaltyData?.iconUrl && <S.GoTribeImg src={goTribeLoyaltyData?.iconUrl} />}
        </S.GoTribeSuperStarImgWrapper>
      </S.GoTribeReviewFooterHeaderWrapper>
      <S.GoTribeReviewFooterBodyWrapper isMweb={isMweb}>
        <div>
          {goTribeLoyaltyData?.messageText && (
            <S.GoTribeHeaderText isMweb={isMweb}>
              {goTribeLoyaltyData?.messageText}
            </S.GoTribeHeaderText>
          )}
          {goTribeLoyaltyData?.walletMessage && (
            <S.GoTribeDescText isMweb={isMweb}>
              {goTribeLoyaltyData?.walletMessage}
            </S.GoTribeDescText>
          )}
        </div>
        <S.LoaderWrapper>
          {goTribeLoyaltyData?.pendingStateMessage && (
            <S.GoTribeFooterText isMweb={isMweb}>
              <HappyLoadingIcon margin={`0 ${isMweb ? '0.6rem' : '0.8rem'} 0 0`} />
              {goTribeLoyaltyData?.pendingStateMessage}
            </S.GoTribeFooterText>
          )}
          {goTribeLoyaltyData?.cta && (
            <S.GoTribeFooterCta href={goTribeLoyaltyData?.ctaLink} isMweb={isMweb}>
              {goTribeLoyaltyData?.cta}
            </S.GoTribeFooterCta>
          )}
        </S.LoaderWrapper>
      </S.GoTribeReviewFooterBodyWrapper>
    </S.GoTribeReviewFooterWrapper>
  );
};
